import {Box, HStack, Text} from '@tempo/core';
import Thumbnail from '@components/Thumbnail';
import {ContentType} from '@deezer/next/services/types/contentType';
import HighlightedText from '@components/Navigation/SearchBar/HighlightedText';
import {NavLink} from '@tempo/nextjs';
import React from 'react';
import type {AlbumSearchResult} from '@deezer/next/services/api/Starmania/requests/search/types';

type AlbumSearchResultItemProps = {
	query: string;
	album: AlbumSearchResult;
};

export const AlbumSearchResultItem = ({
	query,
	album,
}: AlbumSearchResultItemProps) => {
	return (
		<NavLink href={album.redirectUrl}>
			<HStack spacing={3}>
				<Thumbnail
					id={String(album.id)}
					picture={album.picture}
					type={ContentType.Album}
					width={'62px'}
					height={'62px'}
					coverLink={false}
				/>
				<Box>
					<Text
						as="h4"
						variant="body.default.regular"
						data-testid="search-item-title"
						noOfLines={1}
					>
						<HighlightedText query={query}>{album.title}</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						noOfLines={1}
						color="text.neutral.secondary.default"
					>
						by{' '}
						<HighlightedText query={query}>
							{album.artists.map(artist => artist.name).join(', ')}
						</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						color="text.neutral.secondary.default"
					>
						Deezer ID:{' '}
						<HighlightedText query={query}>{String(album.id)}</HighlightedText>
					</Text>
					<Text
						variant="body.small.regular"
						color="text.neutral.secondary.default"
					>
						<HighlightedText query={query}>{album.upc}</HighlightedText>
					</Text>
				</Box>
			</HStack>
		</NavLink>
	);
};

export default AlbumSearchResultItem;
